import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Grid,
  Header,
  Icon,
  Modal,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class UnpublishProjectModal extends Component {
  static propTypes = {
    open: PropTypes.bool,
    onConfirm: PropTypes.func,
  }
  static getPropsToState = (props) => {
    const open = props.open;
    return {
      open,
    };
  }
  constructor(props) {
    super(props);
    const state = UnpublishProjectModal.getPropsToState(props);
    this.state = {
      ...state,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = UnpublishProjectModal.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  close(callback) {
    this.setState({
      open: false,
    }, () => {
      if (callback) {
        callback();
      }
    });
  }
  handleOnClose = () => {
    this.close();
  }
  handleUpdate = () => {
    this.props.onConfirm();
  }
  render() {
    const { t } = this.props;
    return (
      <Modal
        basic
        open={this.state.open}
        onClose={this.handleOnClose}
        closeIcon="close"
        size="small"
        closeOnDimmerClick={false}
      >
        <Header>
          {t('Unpublish Project')}?
        </Header>
        <Modal.Content>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <p>
                  {t('Your units on Marketplace will also be unpublished')}
                </p>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button
            basic
            color="red"
            inverted
            onClick={this.handleOnClose}
          >
            <Icon name="remove" /> {t('Cancel', { ns: TRANSLATION_FILES.translation })}
          </Button>
          <Button
            color="green"
            inverted
            onClick={this.handleUpdate}
          >
            <Icon name="checkmark" /> {t('Save', { ns: TRANSLATION_FILES.translation })}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation(namespaces)(UnpublishProjectModal);
 


// WEBPACK FOOTER //
// ./src/containers/Project/UnpublishProjectModal.jsx